import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

import { AuthProvider } from './contexts/AuthContext';
import LoginComptable from './pages/LoginComptable';
import LoginAdmin from './pages/LoginAdmin';
import DashboardComptable from './pages/DashboardComptable';
import DashboardAdmin from './pages/DashboardAdmin';
import theme from './styles/theme';
import DocumentManagementPage from './components/Comptable/documents/GestionDocuments';
import Dashboard from './components/Comptable/Dashboard';
import GestionClients from "./components/Comptable/clients/GestionClients";
import AutoRedirect from './AutoRedirect';
import PrivateRoute from './contexts/PrivateRoute';
import MaintenancePage from './pages/MaintenancePage';
import PlanComptableImport from "./components/Comptable/clients/PlanComptable";
import NotificationsBoot from './boot/NotificationsBoot';
import IntegrationComptable from "./components/Comptable/documents/IntegrationComptable/IntegrationComptable";
import DocumentsClassificationPage from './components/Comptable/documents/DocumentsClassificationPage';
import NotificationsPage from './components/Comptable/notifications/NotificationsPage';
import EditProfilePage from './components/Comptable/profile/EditProfilePage'; // ← Nouvel import
import ClientDocumentsPage from './pages/ClientDocumentsPage';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentFailed from './pages/PaymentFailed';
import CertificationPage from './components/Comptable/certification/CertificationPage';
function App() {
  const isMaintenanceMode = process.env.REACT_APP_MAINTENANCE_MODE === 'true';
  if (isMaintenanceMode) {
    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <MaintenancePage />
      </ThemeProvider>
    );
  }
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <NotificationsBoot />
        <Router>
          <Routes>
            <Route path="/" element={<AutoRedirect />} />
            
            <Route path="/login" element={<LoginComptable />} />
            <Route path="/admin/login" element={<LoginAdmin />} />
            
            <Route path="/dashboard" element={
              <PrivateRoute>
                <DashboardComptable />
              </PrivateRoute>
            }>
              <Route index element={<Dashboard />} />
              <Route path="documents" element={<DocumentManagementPage />} />
              <Route path="documents/classement" element={<DocumentsClassificationPage />} />
              <Route path="clients" element={<GestionClients />} />
              <Route path="plan" element={<PlanComptableImport />} />
              <Route path="integration" element={<IntegrationComptable />} />
              <Route path="clients/:clientId/plan" element={<PlanComptableImport />} />
              <Route path="notifications" element={<NotificationsPage />} />
              <Route path="profile" element={<EditProfilePage />} />
              <Route path="certification" element={<CertificationPage />} />
            </Route>

            <Route
                path="/clients/:clientId/plan-comptable"
                element={<Navigate to="/dashboard/clients/:clientId/plan" replace />}
            />

            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/failed" element={<PaymentFailed />} />

            <Route path="/admin" element={
              <PrivateRoute requireAdmin={true}>
                <DashboardAdmin />
              </PrivateRoute>
            } />
                          <Route path="/client-documents/:clientId" element={<ClientDocumentsPage />} />

                          <Route path="*" element={<div>404</div>} />
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;